export const NO_CONTACT_DETAILS_ERROR = 'Please enter at least one contact detail';
export const INVALID_EMAIL_ERROR = 'Please enter a valid email address';
export const INVALID_PHONE_ERROR = 'Please enter a valid phone number (no letters allowed)';
export const INVALID_MOBILE_ERROR = 'Please enter a valid mobile number (no letters allowed)';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[0-9\s\-+().]+$/;

/** Fields a user types or picks themselves. `company` is excluded because it is auto-populated from the customer. */
export interface ContactFormValues {
  title: string;
  firstName: string;
  surname: string;
  email: string;
  phone: string;
  mobile: string;
  preferredContactMethod: string;
  jobTitle: string;
  notes: string;
}

/**
 * No individual field is mandatory, but a contact must carry at least one user-entered detail.
 * Format rules still apply to whatever was populated. Applies to both creating and editing a contact.
 */
export function validateContactForm(values: ContactFormValues): string | null {
  const enteredValues = [
    values.title,
    values.firstName,
    values.surname,
    values.email,
    values.phone,
    values.mobile,
    values.preferredContactMethod,
    values.jobTitle,
    values.notes,
  ];

  if (!enteredValues.some((x) => x.trim() !== '')) {
    return NO_CONTACT_DETAILS_ERROR;
  }

  if (values.email.trim() !== '' && !EMAIL_PATTERN.test(values.email.trim())) {
    return INVALID_EMAIL_ERROR;
  }

  if (values.phone.trim() !== '' && !PHONE_PATTERN.test(values.phone.trim())) {
    return INVALID_PHONE_ERROR;
  }

  if (values.mobile.trim() !== '' && !PHONE_PATTERN.test(values.mobile.trim())) {
    return INVALID_MOBILE_ERROR;
  }

  return null;
}
